// js
import { connect } from 'react-redux';
import { openImportSourcesModal, dismissImportSourcesModal, importXLSFiles, downloadXLSTemplates } from '../../actions/xlsImportActions';
import { fetchDSA } from '../../actions/dsaActions';
import ImportSourcesButton from '../../components/sources/ImportSourcesButton';


const mapStateToProps = (state) => {

  return {
    dsa: state.dsa.dsa,
    modalOpen: state.xlsImports.modalOpen,
    importResults: state.xlsImports.importResults,
    importErrors: state.xlsImports.importErrors,
    importing: state.xlsImports.importing
  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    onClick: () => dispatch(openImportSourcesModal()),
    onDismissModal: () => dispatch(dismissImportSourcesModal()),
    onSubmitImport: (dsa, xlsFiles) => {
      dispatch(importXLSFiles(dsa, xlsFiles))
        .then(() => dispatch(fetchDSA(dsa.id)));
    },
    onDownloadTemplates: settings => dispatch(downloadXLSTemplates(settings))
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onSubmitImport: xlsFiles => dispatchProps.onSubmitImport(stateProps.dsa, xlsFiles),
  onDownloadTemplates: settings => (
    dispatchProps.onDownloadTemplates({ ...settings, dsaType: stateProps.dsa.dsaType })
  )
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ImportSourcesButton);



// WEBPACK FOOTER //
// ./src/containers/sources/ImportSourcesButton.js